import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  faChalkboardTeacher,
  faDownload,
  faExpand,
  faPlay,
  faQuestion
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
  Button as BootstrapButton,
  Button,
  Accordion
} from "react-bootstrap";

import { HiOutlinePresentationChartBar } from "react-icons/hi";
import { LeccionesDeApoyo } from "../CursoPropedeutico/LeccionesDeApoyo";
import { Proyectos } from "../CursoPropedeutico/Proyectos";

const CursoPropedeuticoMos = ({
  codigo,
  setCodigo,
  urlVideo,
  setUrlVideo,
  verLeccionDeApoyo,
  materialApoyo,
  verProyecto,
  tab,
  width,
  handleStartTour
}) => {
  const { t } = useTranslation();
  const iframeRef = useRef();

  const requestFullscreen = () => {
    iframeRef.current?.requestFullscreen();
  };

  useEffect(() => {
    if (tab === "propedeutico") {
      setUrlVideo(null);
      setCodigo(null);
    }
  }, [tab]);

  return (
    <>
      {/* 🔹 BOTÓN TOUR */}
      <Row className="justify-content-end mt-4">
        {width > 768 && (
          <Col className="col-auto question-propedeutico end-propedeutico">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{t("cursoPropedeuticoMos.tooltips.tour")}</Tooltip>}
            >
              <span>
                <FontAwesomeIcon
                  className="mx-5 pointer"
                  onClick={handleStartTour}
                  style={{ fontSize: "2rem" }}
                  icon={faQuestion}
                />
              </span>
            </OverlayTrigger>
          </Col>
        )}
      </Row>

      <Row className="justify-content-center mt-3 mb-5">
        {/* 🔹 LECCIONES + PROYECTOS */}
        <Col className="col-12 col-lg-6 mt-4 mt-lg-0 lecciones-mos">
          <Accordion defaultActiveKey="0">

            {/* LECCIONES */}
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <h5>
                  <HiOutlinePresentationChartBar />{" "}
                  {t("cursoPropedeuticoMos.sections.lessons")}
                </h5>
              </Accordion.Header>

              <Accordion.Body className="contenedor-lecciones pt-3">
                <Table striped borderless>
  <tbody>
    {LeccionesDeApoyo.map((Leccion, key) => {
      const nombreTraducido = t(`leccionesMOS.${Leccion.codigoLeccion}`);

      return (
        <tr
          key={key}
          style={{
            backgroundColor:
              codigo === Leccion.codigoLeccion ? "#ffc107" : ""
          }}
        >
          <td>
            <h5>{`${key + 1}- ${nombreTraducido}`}</h5>
          </td>

          <td>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  {t("cursoPropedeuticoMos.tooltips.play")}
                </Tooltip>
              }
            >
              <span>
                <FontAwesomeIcon
                  className="pointer"
                  icon={faPlay}
                  onClick={() =>
                    verLeccionDeApoyo(
                      nombreTraducido, // 🔥 ahora pasa el traducido
                      Leccion.codigoLeccion
                    )
                  }
                />
              </span>
            </OverlayTrigger>
          </td>
        </tr>
      );
    })}
  </tbody>
</Table>
              </Accordion.Body>
            </Accordion.Item>

            {/* PROYECTOS */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <h5>
                  <HiOutlinePresentationChartBar />{" "}
                  {t("cursoPropedeuticoMos.sections.projects")}
                </h5>
              </Accordion.Header>

              <Accordion.Body className="contenedor-lecciones pt-3">
                <div className="d-grid gap-2 mb-3">
                  <Button onClick={materialApoyo} size="lg">
                    <FontAwesomeIcon icon={faDownload} />{" "}
                    {t("cursoPropedeuticoMos.buttons.downloadMaterial")}
                  </Button>
                </div>

                <Table striped borderless>
  <tbody>
    {Proyectos.map((Proyecto, key) => {
      const nombreTraducido =
        t(`proyectosMOS.${Proyecto.codigoProyecto}`) ||
        Proyecto.nombreProyecto;

      return (
        <tr
          key={key}
          style={{
            backgroundColor:
              codigo === Proyecto.codigoProyecto ? "#ffc107" : ""
          }}
        >
          <td>
            <h5>{`${key + 1}- ${nombreTraducido}`}</h5>
          </td>

          <td>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  {t("cursoPropedeuticoMos.tooltips.play")}
                </Tooltip>
              }
            >
              <span>
                <FontAwesomeIcon
                  className="pointer"
                  icon={faPlay}
                  onClick={() =>
                    verProyecto(
                      nombreTraducido, // 👈 traducido
                      Proyecto.codigoProyecto // 👈 fuente real
                    )
                  }
                />
              </span>
            </OverlayTrigger>
          </td>
        </tr>
      );
    })}
  </tbody>
</Table>
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>
        </Col>

        {/* 🔹 VISOR */}
        <Col className="col-12 col-lg-6 mt-4 mt-lg-0 visor-mos">
          {urlVideo !== null && (
            <Row className="justify-content-end mb-2">
              <Col className="col-auto">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      {t("cursoPropedeuticoMos.tooltips.fullscreen")}
                    </Tooltip>
                  }
                >
                  <BootstrapButton onClick={requestFullscreen}>
                    <FontAwesomeIcon icon={faExpand} />
                  </BootstrapButton>
                </OverlayTrigger>
              </Col>
            </Row>
          )}

          {urlVideo === null ? (
            <div className="text-center mt-5 mb-5 text-muted">
              <FontAwesomeIcon icon={faChalkboardTeacher} size="4x" />
              <h4 className="mt-3">
                {t("cursoPropedeuticoMos.emptyState.title")}
              </h4>
            </div>
          ) : (
            <iframe
              ref={iframeRef}
              className="ratio ratio-16x9"
              style={{ border: "none" }}
              width="100%"
              height="100%"
              src={urlVideo}
              title="video"
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default CursoPropedeuticoMos;